<template>
  <div class="dropdown" v-if="options">
    <input type="text" class="dropdown-input"
      :name="name"
      @focus="showOptions"
      @blur="exit"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value" @input="$emit('input', $event.target.value)"
      autocomplete="off"/>

    <div class="dropdown-content" v-show="optionsShown">
      <div class="dropdown-item" @mousedown="selectOption(index)" v-for="(option, index) in filteredOptions" :key="index">
          {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Autocomplete',
    template: 'Autocomplete',
    props: {
      name: {
        type: String,
        required: false,
        default: 'dropdown',
      },
      options: {
        type: Array,
        required: true,
        default: [],
      },
      placeholder: {
        type: String,
        required: false,
        default: '',
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      value: {
        default: ''
      }
    },
    data() {
      return {
        optionsShown: false,
        searchFilter: ''
      }
    },
    created() {
    },
    computed: {
      filteredOptions() {
        return this.options;
        //@todo fix RegExp - search not working properly
        // const filtered = [];
        // const regOption = new RegExp(this.searchFilter, 'ig');

        // for (let i = 0; i < this.options.length; i++) {
        //   if (this.options[i].match(regOption)) {
        //     filtered.push(this.options[i]);
        //   }
        // }
        // return filtered;
      }
    },
    methods: {
      selectOption(idx) {
        this.$emit('input', this.options[idx])
        this.$emit('selected', this.options[idx]);
        this.optionsShown = false;
      },
      showOptions(){
        if (!this.disabled) {
          this.optionsShown = true;
        }
      },
      exit() {
        this.optionsShown = false;
      }
    },
    watch: {
      value(value) {
        this.$emit('search', value);
        this.searchFilter = value;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .dropdown {
    position: relative;
    display: block;
    margin: auto;
    .dropdown-input {    
      -webkit-appearance: menulist-button;
      -moz-appearance: menulist-button;

      background: #fff;
      cursor: pointer;
      border: 1px solid #ced4da;
      border-radius: 3px;
      color: #35495e;
      display: block;
      font-size: 1em;
      padding: 6px 6px 6px 10px;
      width: 100%;
      min-height: 20px;
      &:hover {
        cursor: text;
      }
    }
    .dropdown-content {
      position: absolute;
      background-color: #fff;
      width: 100%;
      min-height: 20px;
      border: 1px solid #4fc1e9;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      overflow: auto;
      z-index: 1;
      // border-radius: 0px 0px 5px 5px;
      .dropdown-item {
        padding: 1px 0px 1px 10px;
        text-decoration: none;
        display: block;
        width: 100%;
        min-height: 20px;
        font-size: 1em;
        &:hover {
          background-color: #2386E0;
          color: #fff;
        }
      }
    }
    .dropdown:hover .dropdowncontent {
      display: block;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/global/miscellaneous/Autocomplete.vue